import { useView } from '@10000/react'
import { Box } from '../widgets'
import { InputScreen, useShell, useStack } from '../layout'
import { SelectableList } from '../forms'
import { SquizOptions } from '.'
import { teamIsComplete } from '../onboarding'

export const SelectTeam = ({ active, organisationId }) => {
  const { push } = useStack()
  const { teams } = useView('tenant')

  useShell({ active, mode: 'navigate' })
  const filteredTeams = (organisationId ? teams.filter(x => x?.organisation === organisationId) : teams)
    .filter(x => teamIsComplete(x))

  const teamSelected = ({ team }) => team !== undefined && push(SquizOptions, { props: { teamId: filteredTeams[team].id } })

  return (
    <InputScreen centered onSubmit={teamSelected} footerButton="Select" title="Select Team">
      <Box className="scrolling-list">
        <SelectableList
          name="team"
          list={filteredTeams.map(x => x.name)}
        />
      </Box>
    </InputScreen>
  )
}